import React from "react";
import { useTranslation } from "react-i18next";

const RequestSummary = ({ info, expanded, onToggle }) => {
    const { t, i18n } = useTranslation("common");
    

    const isArabic = i18n.language === "ar";

    if (!info) {
        return null;
    }

    const getLocalizedValue = (field) => {
        const languageField = `${field}_${isArabic ? "AR" : "EN"}`;
        return info[languageField];
    };

    const fields = [
        {
            label: "summaryDepartment",
            value: getLocalizedValue("Department_Name"),
        },
        {
            label: "summaryRequestNo",
            value: info.Request_No,
        },
        {
            label: "summaryServiceName",
            value: getLocalizedValue("Service_Name"),
        },
        {
            label: "summaryVersion",
            value: info.Department_Service_Version_Name,
        },
        {
            label: "summaryRequestDate",
            value: info.Request_Date_Formatted,
        },

        {
            label: "summaryOwnerName",
            value: info.Owner_Name,
        },
        {
            label: "summaryPlotNo",
            value: info.Plot_No,
        },
        {
            label: "summaryArea",
            value: getLocalizedValue("Area_Name"),
        },
        {
            label: "summaryConsultantLicense",
            value: info.Consultant_Lic_No,
        },
        {
            label: "summaryConsultantName",
            value: getLocalizedValue("Consultant_Lic_Name"),
        },
        {
            label: "summaryContractorLicense",
            value: info.Contractor_Lic_No,
        },
        {
            label: "summaryContractorName",
            value: getLocalizedValue("Contractor_Lic_Name"),
        },
        {
            label: "summaryRequestType",
            value: info.Request_Type,
        },
        {
            label: "summaryConstructionUsing",
            value: info.Construction_Using,
        },
        {
            label: "summaryBuildingPermissionNo",
            value: info.Buidling_Permission_No,
        },
        {
            label: "summaryBuildingPermissionYear",
            value: info.Buidling_Permission_Year,
        },
        {
            label: "summaryBuildingPermissionDate",
            value: info.Buidling_Permission_Issue_Date,
        },
        {
            label: "summaryLicensedBuilding",
            value: info.Licensed_Building,
        },
        {
            label: "summaryFinishedBuilding",
            value: info.Finished_Building,
        },
        {
            label: "summaryBuildingArea",
            value: info.Building_Area,
        },
        {
            label: "summaryProjectNo",
            value: info.Project_No,
        },
        {
            label: "summaryProjectValue",
            value: info.Project_Value,
        },
        {
            label: "summaryInsurancePaymentNo",
            value: info.Insurance_Refund_Payment_No,
        },
        {
            label: "summaryInsuranceInvoiceNo",
            value: info.Insurance_Refund_Invoice_No,
        },
        {
            label: "summaryInsuranceInvoiceDate",
            value: info.Insurance_Refund_Invoice_Date,
        },
        {
            label: "summaryInsuranceValue",
            value: info.Insurance_Refund_Value,
        },
        {
            label: "summaryInsuranceRequestNo",
            value: info.Insurance_Refund_Invoice_Request_No,
        },
        {
            label: "summaryInsuranceRefundDate",
            value: info.Insurance_Refund_Date,
        },
        {
            label: "summaryInsuranceAccount",
            value: info.Insurance_Refund_IBAN_Account,
        },
        {
            label: "summaryInsuranceCode",
            value: info.Insurance_Refund_Code,
        },
    ];

    const hasValue = (value) => {
        if (value === null || value === undefined) {
            return false;
        }

        if (typeof value === "string") {
            return value.trim() !== "";
        }

        if (typeof value === "number") {
            return value !== 0;
        }

        return true;
    };

    const visibleFields = fields.filter((field) =>
        hasValue(field.value)
    );

    return (
        <div
            style={{
                width: "100%",
                marginTop: "20px",
                marginBottom: "20px",
                backgroundColor: "#ffffff",
                border: "1px solid #e6e9e4",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            }}
            dir={isArabic ? "rtl" : "ltr"}
        >
            <button
                type="button"
                onClick={onToggle}
                aria-expanded={expanded}
                style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f5f8f2",
                    padding: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    color: "#287d32",
                    fontWeight: 600,
                    fontSize: "14px",
                    textAlign: isArabic ? "right" : "left",
                }}
            >
                <span>{t("requestSummaryTitle")}</span>

                <span
                    style={{
                        fontSize: "12px",
                        transition: "transform 0.2s",
                        transform: expanded
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                    }}
                >
                    ▼
                </span>
            </button>

            {expanded && (
                <div style={{ padding: "5px 12px" }}>
                    {visibleFields.map((field, index) => (
                        <div
                            key={field.label}
                            style={{
                                padding: "10px 0",
                                borderBottom:
                                    index === visibleFields.length - 1
                                        ? "none"
                                        : "1px solid #edf0ed",
                            }}
                        >
                            <div
                                style={{
                                    color: "#689f38",
                                    fontSize: "11px",
                                    marginBottom: "5px",
                                    fontWeight: 500,
                                }}
                            >
                                {t(field.label)}
                            </div>

                            <div
                                style={{
                                    color: "#333333",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "1.6",
                                    overflowWrap: "anywhere",
                                    unicodeBidi: "plaintext",
                                }}
                            >
                                {field.value}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RequestSummary;